<div class="row mb-3">
    <label class="col-2 col-form-label" translate="CONFIRMATION_EVENT_SUMMARY_PRIMARY_PURPOSE_OF_TRAINING"></label>
    <div class="col-6">
        <pace-core-dropdown [(model)]="model.primaryPurposeOfTraining" [parentForm]="parentForm"></pace-core-dropdown>
    </div>
</div>
<div class="row mb-3">
    <label class="col-2 col-form-label" translate="CONFIRMATION_EVENT_SUMMARY_TRAINING_FOCUS"></label>
    <div class="col-6">
        <pace-core-dropdown
            [(model)]="model.trainingFocus"
            (valueChange)="onTrainingFocusValueChange()"
            [parentForm]="parentForm"
        ></pace-core-dropdown>
    </div>
</div>
<div class="row mb-3" *ngIf="showOtherTrainingFocusField">
    <label class="col-2 col-form-label" translate="CONFIRMATION_EVENT_SUMMARY_OTHER_TRAINING_FOCUS"></label>
    <div class="col-6">
        <pace-core-text-input [(model)]="model.otherTrainingFocus" [parentForm]="parentForm"></pace-core-text-input>
    </div>
</div>
<div class="row mb-3">
    <label
        class="col-2 col-form-label"
        translate="CONFIRMATION_EVENT_SUMMARY_PRIMARY_PRODUCT_AND_OR_TOPICS_TRAINED"
    ></label>
    <div class="col-6">
        <pace-core-text-input
            [(model)]="model.primaryProductAndOrTopicTrained"
            [parentForm]="parentForm"
        ></pace-core-text-input>
    </div>
</div>
<div class="row mb-3">
    <label class="col-2 col-form-label" translate="CONFIRMATION_EVENT_SUMMARY_SYSTEM_SOFTWARE_VERSION"></label>
    <div class="col-6">
        <pace-core-text-input [(model)]="model.systemSoftwareVersion" [parentForm]="parentForm"></pace-core-text-input>
    </div>
</div>

<div class="row mb-3">
    <label
        class="col-6 offset-2 col-form-label text-start"
        translate="CONFIRMATION_EVENT_SUMMARY_TRAINEES_ATTENDED_CLASSROOM"
    ></label>
    <div class="col-6 offset-2">
        <pace-core-radio-input
            [(model)]="model.traineesAttendedClassroom"
            [parentForm]="parentForm"
        ></pace-core-radio-input>
    </div>
</div>
<div class="row mb-3">
    <label
        class="col-6 offset-2 col-form-label text-start"
        translate="CONFIRMATION_EVENT_SUMMARY_SYSTEM_OPTIONS_REVIEWED"
    ></label>
    <div class="col-8 offset-2">
        <pace-core-radio-input
            [(model)]="model.systemOptionsReviewed"
            [parentForm]="parentForm"
        ></pace-core-radio-input>
    </div>
</div>
